import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"
import Icon from "./elements/Icon"

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a
            class={`pagination-custom__page ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({
        width: 5
    })
    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        <nav class="pagination-custom">
            {prev && (
                <span>
                    <PageLink {...pageLinkProps(prev)} className="ns-previous" ariaLabel="Previous">
                        Previous
                    </PageLink>
                </span>
            )}

            <div class="pagination-custom__inner">
            {first && (
                <>
                    <span>
                        <PageLink {...pageLinkProps(first)} ariaLabel="First">
                            {first.page}
                        </PageLink>
                    </span>
                    <span class="pagination-custom__sep">...</span>
                </>
            )}

            
            {pages.map(page => (
                    <span class={`${page.current ? "pagination-custom__page--active" : ""}`}>
                        <PageLink {...pageLinkProps(page)}>{page.page}</PageLink>
                    </span>
            ))}
            

            {last && (
                <>    
                    <span class="pagination-custom__sep">...</span>
                    <span>
                        <PageLink {...pageLinkProps(last)} ariaLabel="Last">{last.page}</PageLink>
                    </span>
                </>
            )}
            </div>

            {next && (
                <span>
                    <PageLink {...pageLinkProps(next)} className="pagination-custom__next" ariaLabel="Next">
                        Next
                    </PageLink>
                </span>
            )}
        </nav>
    )
}
